import Netx from '@netx/core/bootstrap';
import type {PaletteMode} from '@mui/material';
import {getStylePropertyDemo} from './getStylePropertyDemo';

export const getStylePropertyFn = (
	mode: PaletteMode,
	opts?: {demo?: boolean},
) => {
	const {demo} = opts || {};

	return !demo && Netx.getStyleProperty
		? Netx.getStyleProperty
		: (key: string) => getStylePropertyDemo(key, mode);
};
